import { useState } from 'react';

import { Drawer } from '../../../../../../components/index';
import { Stopover as StopoverType } from '../../../../../../types';
import { StopoverEditForm } from './stopoverEditForm';

type StopoverEditDrawerProps = {
  visible: boolean;
  width: number;
  onBack: () => void;
  selectedStopover?: StopoverType;
  setSelectedStopover?: (value: StopoverType) => void;
  setIsVisibleForm: (value: boolean) => void;
};

export function StopoverEditDrawer(props: StopoverEditDrawerProps) {
  const {
    visible,
    width,
    onBack,
    selectedStopover,
    setSelectedStopover,
    setIsVisibleForm,
  } = props;

  const [formIsChanged, setIsFormChanged] = useState(false);
  const [blockNavigate, setBlockNavigate] = useState(false);

  return (
    <Drawer
      visible={visible}
      width={width}
      onClose={() => onBack()}
      closable={false}
      maskClosable={false}
    >
      <StopoverEditForm
        selectedStopover={selectedStopover}
        setSelectedStopover={setSelectedStopover}
        onFinishSubmit={onBack}
        onBack={onBack}
        setIsVisibleForm={setIsVisibleForm}
        formIsChanged={formIsChanged}
        setIsFormChanged={setIsFormChanged}
        setBlockNavigate={setBlockNavigate}
        blockNavigate={blockNavigate}
      />
    </Drawer>
  );
}
